import React, { useEffect, useState } from 'react';

// Config URL video hướng dẫn (mua sắm hoàn tiền) — file tĩnh trên backend.
// Đổi video: upload R2 + sửa URL trong guide-videos.json → web tự nhận, không build lại.
// Trình duyệt + CDN tự cache theo URL (load 1 lần).
const CONFIG_URL = `${process.env.REACT_APP_API_PUBLIC_URL || ''}/img/guide-videos.json`;
const VALID = ['shopee', 'lazada', 'tiktok', 'shopeefood'];

// Mặc định bake sẵn URL R2 → web có video kể cả khi backend chưa deploy config.
// Config backend/admin sẽ override khi fetch thành công.
const R2 = 'https://pub-d1efaa6ee9c142a9899ee83852948a4b.r2.dev/Video%20App';
const DEFAULT_VIDEOS = {
    shopee: `${R2}/shopee_720.mp4`,
    lazada: `${R2}/lazada_720.mp4`,
    tiktok: `${R2}/tiktok_720.mp4`,
};

// `message` — text tuỳ biến (vd ShopeeFood: dán link quán thay vì sản phẩm)
function LongHouseePet({ platform, message }) {
    const key = (platform || '').toLowerCase();
    const [videoUrl, setVideoUrl] = useState(DEFAULT_VIDEOS[key] || '');
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        if (!VALID.includes(key)) return undefined;
        let alive = true;
        fetch(`${CONFIG_URL}?t=${Date.now()}`, { cache: 'no-cache' })
            .then((r) => r.json())
            .then((data) => {
                const url = data?.videos?.[key]?.url;
                if (alive && typeof url === 'string' && /^https?:\/\//.test(url)) {
                    setVideoUrl(url);
                }
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, [key]);

    const showVideo = videoUrl && !failed;

    return (
        <div className="bg-surface flex-col flex justify-center items-center p-2">
            {showVideo ? (
                <div className="w-44 aspect-[3/4] rounded-xl overflow-hidden bg-surface-muted">
                    <video
                        src={videoUrl}
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        onError={() => setFailed(true)}
                    />
                </div>
            ) : (
                <div className="w-40">
                    <img src="/img/ui/longicon.png" alt="longicon" />
                </div>
            )}
            <div className="text-center px-12">
                <p>
                    {message ||
                        ` Nhập link ${
                            platform || ''
                        } để Longhousee tìm sản phẩm và hoàn tiền cho
                    nhen!`}
                </p>
            </div>
        </div>
    );
}

export default LongHouseePet;
